/**
 * Created by shard on 16/7/15.
 */
module.exports = {
    //校验数字
    checkNum: function (value) {
        var reg = /^\d+$/;
        return reg.test(value);
    },
    //校验电话
    checkTel: function (value) {
        var reg = /^[0-9-]+/;
        return reg.test(value);
    },
    //校验手机号
    checkMobile: function (value) {
        //var reg = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])[0-9]{8}$/;
        var reg = /^1\d{10}$/;
        return reg.test(value);
    },
    //校验金额
    checkPrice: function (value) {
        var reg = /^(\d{1,10}(\.\d{0,2})?)$/;
        return reg.test(value);
    },
    //校验验证码
    checkSmsCode: function (value) {
        var reg = /^\d{4}$/;
        return reg.test(value);
    },
    //校验密码
    checkPassword: function (value) {
        var reg = /^((?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{6,20})$/;
        return reg.test(value);
    },
    //校验楼层号
    checkFloorCode: function (value) {
        var reg = /^[0-9a-zA-Z]{1,4}$/;
        return reg.test(value);
    },
    //校验身份证
    checkIdCard: function (value) {
        var exg = /^(\d{17}[0-9X]{1})$/;
        return exg.test(value);
    },
    //校验护照
    passport: function (value) {
      var exg =  /^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
      return exg.test(value);
    },
    //校验房间名
    checkRoomNo: function (value) {
        var reg = /^[0-9a-zA-Z]{1,6}$/;
        return reg.test(value);
    },
    //校验房间名
    checkApartmentCode: function (value) {
        var reg = /^[0-9a-zA-Z]{1,15}$/;
        return reg.test(value);
    },
    //校验图片类型
    isImage:function (value) {
        var reg = /\.(png|jpg|gif|jpeg|webp)$/;
        return reg.test(value);
    },
    //金额保留1为小数
    theSeparator:function (e) {
      if (e!=0&&e!=undefined){
        e=e.toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      } else if (e == 0){
        e = '0.0'
      }
      return e;
    },
  //转化日期格式
  dateonversion:function (value) {
    var date=new Date(value);
    let datetime1=date.getFullYear() + '-' + ((date.getMonth() + 1)<10?'0'+(date.getMonth() + 1):(date.getMonth() + 1)) + '-' + (date.getDate()<10?'0'+date.getDate():date.getDate());
    return datetime1;
  },
  //家具清单字符串转数组
  furniturelistHandle(houseAppliances){
    if (houseAppliances!=''&&houseAppliances!=undefined){
      let list=this.furnitureListInit();
      let otherValue="";
      let arr1=[];
      let arr2=[];
      let furnitureList=houseAppliances.split(",");
      furnitureList.forEach((item)=>{
        let currentItemList=item.split('(');
        list.forEach(element=>{
          if (currentItemList[0]==element.name){
            element.brand=item.slice(item.indexOf('(')+1,item.indexOf(')'));
            element.number=item.slice(item.indexOf('*')+1)
          }

        });
        arr1.push(currentItemList[0])
      });
      list.forEach(item=>{
        arr2.push(item.name)
      });
      let fewValue = arr1.filter(item => !arr2.includes(item));
      if (fewValue&&fewValue.length>0){
        let currentItemIndex=[];
        let fewValueIndex=[];
        let fewValue1=[];
        let flag=false;
        fewValue.forEach((item,index)=>{
          if (item.indexOf('*')!=-1){
            flag=true;
          }
          let currentItemList=item.split("*");
          list.forEach(element=>{
            if (currentItemList[0]==element.name){
              element.brand='';
              element.number=item.slice(item.indexOf('*')+1);
              currentItemIndex.push(index);
            }

          });
          fewValueIndex.push(index)
        });
        if (currentItemIndex&&currentItemIndex.length>0){
          let surplusIndexList = fewValueIndex.filter(item => !currentItemIndex.includes(item));
          surplusIndexList.forEach(item=>{
            fewValue1.push(fewValue[item])
          })
        }
        furnitureList.forEach(item=>{
          let currentItemList=item.split('(');
          fewValue1.forEach(element=>{
            if (currentItemList[0]==element){
              if (otherValue!=''&&otherValue!=undefined){
                otherValue=otherValue+','+item;
              }else {
                otherValue=item;
              }
            }
          })
        });
        if (flag!==true){
          fewValue.forEach(item=>{
            if (otherValue!=''&&otherValue!=undefined){
              otherValue=otherValue+','+item;
            }else {
              otherValue=item;
            }
          })
        }
      }
      return {'furnitureList':list, 'otherValue':otherValue,}
    }else {
      return {'furnitureList':[], 'otherValue':'',}
    }
  },
  //家具清单初始化数据
  furnitureListInit:function () {
    let list=[{
      name:"床",
      brand:"",
      number:0
    },{
      name:"床头柜",
      brand:"",
      number:0
    },{
      name:"鞋柜",
      brand:"",
      number:0
    },{
      name:"衣柜",
      brand:"",
      number:0
    },{
      name:"书桌",
      brand:"",
      number:0
    },{
      name:"椅子",
      brand:"",
      number:0
    },{
      name:"餐桌",
      brand:"",
      number:0
    },{
      name:"餐椅",
      brand:"",
      number:0
    },{
      name:"沙发",
      brand:"",
      number:0
    },{
      name:"茶几",
      brand:"",
      number:0
    },{
      name:"电视柜",
      brand:"",
      number:0
    },{
      name:"洗衣机",
      brand:"",
      number:0
    },{
      name:"冰箱",
      brand:"",
      number:0
    },{
      name:"空调",
      brand:"",
      number:0
    },{
      name:"热水器",
      brand:"",
      number:0
    },{
      name:"抽油烟机",
      brand:"",
      number:0
    },{
      name:"炉灶",
      brand:"",
      number:0
    },{
      name:"电视",
      brand:"",
      number:0
    },{
      name:"微波炉",
      brand:"",
      number:0
    }];
    return list
  }
    //金额计算
    // addNumber:function (x,y) {
    //   return new this(x).plus(y);
    // }(this)
};



// WEBPACK FOOTER //
// ./src/assets/js/validate.js